// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../common/temp/default/node_modules/.pnpm/@rsbuild+core@1.1.13/node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../common/temp/default/node_modules/.pnpm/@rsbuild+core@1.1.13/node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chat-input-FUjI0t{flex-direction:column;align-items:center;width:100%;display:flex;position:relative}.chat-input-wrapper-efPQGD{width:100%;padding:0 24px}.safe-area-m1haRS{width:100%}.safe-area-pc-cCdlsE{height:24px}.safe-area-mobile-Cn22VW{height:8px}.mask-BzcZQ8{pointer-events:none;z-index:5;background:linear-gradient(180deg,rgba(255,255,255,0) 0%,var(--uikit-chat-input-primary-color,#fff)100%);width:100%;height:48px;position:absolute;top:-48px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"chat-input": `chat-input-FUjI0t`,
	"chatInput": `chat-input-FUjI0t`,
	"chat-input-wrapper": `chat-input-wrapper-efPQGD`,
	"chatInputWrapper": `chat-input-wrapper-efPQGD`,
	"safe-area": `safe-area-m1haRS`,
	"safeArea": `safe-area-m1haRS`,
	"safe-area-pc": `safe-area-pc-cCdlsE`,
	"safeAreaPc": `safe-area-pc-cCdlsE`,
	"safe-area-mobile": `safe-area-mobile-Cn22VW`,
	"safeAreaMobile": `safe-area-mobile-Cn22VW`,
	"mask": `mask-BzcZQ8`
};
export default ___CSS_LOADER_EXPORT___;
